import { memo, useEffect, useMemo, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { HandleModalProps } from "@/types/props";
import { emptyBachelorDegree, emptyScholarshipTitle } from "@/models/empty";
import { iBachelorDegree } from "@/types/models";
import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { ZodError } from "../ZodDisplayError";
import { format } from "date-fns";
import { vi } from "date-fns/locale";
import { CalendarIcon, ChevronDown, RefreshCw } from "lucide-react";
import { Calendar } from "../ui/calendar";
import { bachelorDegreeSchema, tBachelorDegreeSchema } from "../validations/bachelorDegree";
import { classificationList, ethnicCodeAndNameList, majorCodesWithName, nationalityCodeAndNameList, requestTypeList, trainingMethodList } from "../validations/shared";
import { DropdownMenu, DropdownMenuCheckboxItem, DropdownMenuContent, DropdownMenuTrigger } from "../ui/dropdown-menu";
import { cn } from "../ui/utils";
import { NgocInput } from "../ui/ngocInput";
import { getLocalDate } from "@/lib/utils/func";
import { scholarshipTitleSchema, tScholarshipTitleSchema } from "../validations/scholarshipTitle";




export const ScholarshipTitlteModal = memo(({ isOpen, onClose, onAdd, onUpdate, editData, mode }: HandleModalProps) => {
    const {
        control,
        register,
        handleSubmit,
        reset,
        setValue,
        getValues,
        trigger,
        formState: { errors, isValid },
    } = useForm<tScholarshipTitleSchema>({
        resolver: zodResolver(scholarshipTitleSchema),
        defaultValues: emptyScholarshipTitle,
        mode: "all",
    });


    const submit = (data: tScholarshipTitleSchema) => {
        //= Trim inputs before sending
        data.titleName = data.titleName.trim();
        data.notes = data.notes?.trim();
        switch (mode) {
            case "create":
                onAdd(data as Omit<tScholarshipTitleSchema, "id">);
                break;
            case "edit":
                onUpdate(data);
                break;
        }
        onClose();
    };

    useEffect(() => {
        switch (mode) {
            case "create":
                reset(emptyScholarshipTitle);
                break;
            case "edit":

                reset({
                    ...editData,
                    titleName: editData?.titleName || "",
                    currentTitleName: editData?.titleName || "",
                    notes: editData?.notes || "",
                });
                trigger();
                break;
        }
    }, [isOpen, editData, mode, reset, trigger]);

    const logError = (e: any) => {
        console.log(e);
    };

    return <Dialog
        open={isOpen}
        onOpenChange={() => {
            onClose();
        }}
    >
        <DialogContent className='max-w-6xl'>
            <DialogHeader>
                <DialogTitle>{mode === "create" ? "Thêm Mới" : "Cập Nhật Danh Hiệu"}</DialogTitle>
            </DialogHeader>
            <form onSubmit={handleSubmit(submit, logError)} id='handleBachelorDegreeForm' className='grid grid-cols-1 gap-2 px-1 max-h-[75dvh] overflow-y-auto'>
                <div className='p-2'>
                    <Label className='mb-1 required'>Tên danh hiệu</Label>
                    <Input type='text' placeholder='Nhập tên danh hiệu' maxLength={255} {...register("titleName")} />
                    <ZodError message={errors.titleName?.message} />
                </div>
                <div className='p-2'>
                    <Label className='mb-1'>Ghi chú</Label>
                    <NgocInput rows={3} placeholder='Nhập ghi chú' maxLength={500} {...register("notes")} />
                    <ZodError message={errors.notes?.message} />
                </div>
                <div className='flex justify-end space-x-2 p-4 pt-0'>
                    <Button type='button' variant='destructive' onClick={onClose}>
                        Hủy
                    </Button>
                    <Button type='submit' variant={'add'} disabled={!isValid}>
                        {mode === "create" ? "Thêm Mới" : "Cập Nhật"}
                    </Button>
                </div>
            </form>
        </DialogContent>
    </Dialog>
})